module.exports = __webpack_public_path__ + "img/linkedin-small.ca42e511.svg";